export default [
  {
    path: '/extra-fees',
    name: 'extra-fees',
    component: () => import('../../views/extra-fees/Index.vue'),
    meta: {
      pageTitle: 'Ajouter Frais Extra',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: '/',
        },
        {
          text: 'Colis',
        },
        {
          text: 'Ajouter Frais Extra',
          active: true,
        },
      ],
      requireLogin: true,
      roles: ['admin', 'superadmin', 'admin_developer', 'manager'],
    },
  },
]
